import React, { useState } from 'react';
import axios from 'axios';
import './css/CreateUserPopup.css';

const API_BASE = '';

const CreateUserPopup = ({ onClose, openLoginPopup }) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    mobileNumber: '',
    email: '',
    password: '',
    termsAccepted: false,
    logoFile: null,
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const validateSecurePassword = (password) =>
    /^(?=.*[A-Z])(?=.*\d).{8,}$/.test(password);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : type === 'file' ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.termsAccepted) {
      setError('You must accept the terms to continue.');
      return;
    }

    if (!validateSecurePassword(formData.password)) {
      setError('Password must be at least 8 characters, include one number and one capital letter.');
      return;
    }

    try {
      const form = new FormData();
      form.append('firstName', formData.firstName);
      form.append('lastName', formData.lastName);
      if (formData.mobileNumber) {
        form.append('mobileNumber', formData.mobileNumber);
      }
      form.append('email', formData.email);
      form.append('password', formData.password);
      form.append('termsAccepted', formData.termsAccepted);
      if (formData.logoFile) {
        form.append('logoFile', formData.logoFile);
      }

      await axios.post(`${API_BASE}/api/register`, form);

      setSuccess('✅ Registered successfully!');
      setError('');

      setTimeout(() => {
        onClose();
      }, 1000);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Registration failed.');
      setSuccess('');
    }
  };

  return (
    <div className="create-user-popup">
      <div className="popup-content">
        <h2>Create Account</h2>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              name="firstName"
              type="text"
              placeholder="First Name"
              onChange={handleChange}
              required
            />
            <input
              name="lastName"
              type="text"
              placeholder="Last Name"
              onChange={handleChange}
              required
            />
          </div>
          <input
            name="mobileNumber"
            type="tel"
            placeholder="Mobile Number (optional)"
            onChange={handleChange}
          />
          <input
            name="email"
            type="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />
          <input
            name="password"
            type="password"
            placeholder="Password (min 8 chars incl. number & capital letter)"
            onChange={handleChange}
            required
          />
          <input
            name="logoFile"
            type="file"
            accept="image/*"
            onChange={handleChange}
          />

          <label>
            <input
              type="checkbox"
              name="termsAccepted"
              onChange={handleChange}
              required
            />
            I accept the terms & conditions
          </label>

          <button type="submit">Register</button>
          <button type="button" onClick={onClose}>
            Cancel
          </button>

          {error && <p style={{ color: 'red' }}>{error}</p>}
          {success && <p style={{ color: 'green' }}>{success}</p>}
        </form>
      </div>
    </div>
  );
};

export default CreateUserPopup;

